$(function () {
  $(document).bind('ajaxComplete', function(){
    if(!isMobile()) {
      square('.download-section label');
    }

    $(window).on('resize',function () {
      if(isMobile()) {
        resetSquare('.download-section label');
      } else {
        square('.download-section label');
      }
    })
  });
})
